import React, { FC } from "react";
import hospitalisationImg from "assets/icons/hb.svg";
import otherImg from "assets/icons/ob.svg";
import waitingImg from "assets/icons/wb.svg";
import exclusionImg from "assets/icons/exclusion.svg";
import { areAllObjectsKeysNull } from "utils/utils";
import { BenefitSummaryMobileTabsSkeleton, BenefitSummaryTabsSkeletonWeb } from "./Skeleton/BenefitTab";

interface BenefitsTabsProps {
  activeTab: string;
  setActiveTab: any;
  version: any;
  benefitSumList: any;
}

const BenefitsTabs: FC<BenefitsTabsProps> = ({ activeTab, setActiveTab, version, benefitSumList }) => {
  const benefitSummaryTabs: { webName: string; mobName: string; icon: any; id: string }[] = [{ webName: version === 2 ? "Coverages & Limits" : "Hospitalisation Benefits", id: version === 2 ? "coverageAndLimits" : "hospitalisationBenefits", mobName: version === 2 ? "Coverages & Limits" : "Hospitalisation Benefits", icon: hospitalisationImg }, ...(version === 2 ? [{ webName: "Other Benefits & Limits", mobName: "Other Benefits & Limits", icon: otherImg, id: "otherBenefitsAndLimits" }] : [{ webName: "Other Benefits", mobName: "Other Benefits", icon: otherImg, id: "otherBenefits" }]), { webName: "Waiting Period", mobName: "Waiting Period", icon: waitingImg, id: version === 2 ? "waitingPeriodAndSubLimitsV2" : "waitingPeriodAndSubLimits" }, { webName: "Exclusions", mobName: "Exclusions", icon: exclusionImg, id: "exclusions" }];

  return (
    <div className="relative w-full">
      {/* Web View */}
      {benefitSumList ? (
        <div className={`hidden xl:flex justify-center gap-4 lg:gap-24  text-xs lg:text-sm font-bold `}>
          {benefitSummaryTabs.map((obj, i) => {
            if (areAllObjectsKeysNull(benefitSumList[obj.id])) return;
            return (
              <div key={i} onClick={() => setActiveTab(obj.id)} className={`tab cursor-pointer py-4 flex flex-col items-center transition-all duration-300 ${activeTab === obj.id && "border-b-2 border-black"}`}>
                <div className="flex items-center gap-2 z-10">
                  <img src={obj.icon} alt={obj.webName} />
                  <span>{obj.webName}</span>
                </div>
              </div>
            );
          })}
        </div>
      ) : (
        <BenefitSummaryTabsSkeletonWeb />
      )}

      {/* Mob View */}
      {benefitSumList ? (
        <div className="flex xl:hidden justify-center w-full text-xs font-bold overflow-x-auto scrollbar-hide items-center gap-2">
          {benefitSummaryTabs.map((obj, i) => {
            if (areAllObjectsKeysNull(benefitSumList[obj.id])) return;
            return (
              <div key={i} onClick={() => setActiveTab(obj.id)} className="w-full cursor-pointer py-4 flex items-center justify-center transition-all duration-300">
                <div className={`z-10 flex flex-col gap-2 items-center w-full justify-center text-center ${activeTab === obj.id ? "border-b-2 border-black pt-2" : ""}`}>
                  <img src={obj.icon} alt={obj.mobName} className="h-6 object-contain" />
                  <span className="mb-2">{obj.mobName}</span>
                </div>
              </div>
            );
          })}
        </div>
      ) : (
        <BenefitSummaryMobileTabsSkeleton />
      )}
    </div>
  );
};

export default BenefitsTabs;
